import React from 'react'

const Logo = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="140pt"
      height="40pt"
      viewBox="0 0 600 183.000000"
      preserveAspectRatio="xMidYMid meet"
      id="logo"
    >
      <g
        transform="translate(0.000000,183.000000) scale(0.100000,-0.100000)"
        fill="#0071b9"
        stroke="none"
      >
        <path
          d="M1455 1795 c-38 -9 -112 -36 -162 -61 -157 -78 -262 -215 -297 -387
-20 -94 -20 -154 -2 -250 28 -144 119 -278 241 -356 156 -99 400 -109 585 -25
122 56 233 164 294 288 47 95 59 151 59 276 -1 195 -72 331 -227 436 -115 78
-333 113 -491 79z m299 -135 c190 -65 292 -260 257 -490 -32 -207 -173 -351
-373 -382 -217 -33 -404 77 -472 277 -23 67 -31 196 -17 270 16 85 73 196 124
240 124 107 318 141 481 85z"
        />
        <path
          d="M5076 1779 c-34 -27 -73 -102 -56 -107 50 -17 153 -150 285 -366 l97
-159 -8 -213 c-6 -198 -5 -216 11 -234 20 -22 60 -26 115 -10 62 18 64 21 45
81 -11 36 -18 109 -22 221 l-6 167 90 128 c109 156 220 322 256 384 48 81 31
119 -52 119 -59 0 -71 -8 -71 -45 0 -20 -18 -69 -45 -122 -49 -94 -213 -345
-230 -350 -10 -3 -74 97 -219 342 -88 150 -94 158 -123 173 -30 16 -36 15 -67
-9z"
        />
        <path
          d="M127 1783 l-99 -4 7 -27 c23 -93 28 -164 29 -402 1 -146 -1 -347 -4
-446 -5 -169 -4 -183 14 -203 23 -26 69 -27 128 -4 24 9 44 17 46 18 1 1 -5
21 -13 45 -16 45 -41 318 -30 329 4 3 32 6 63 5 92 0 161 -53 323 -246 279
-330 700 -598 1109 -704 405 -105 867 -69 1288 100 152 61 391 183 502 256
106 70 253 181 247 187 -2 2 -58 -25 -123 -60 -361 -191 -686 -306 -1050 -369
-176 -30 -576 -33 -724 -5 -186 36 -312 78 -485 161 -227 109 -417 253 -599
451 -56 60 -139 148 -186 195 l-85 85 48 24 c59 30 131 106 160 169 18 38 22
65 22 147 0 91 -2 104 -28 147 -36 62 -105 113 -185 138 -66 20 -102 22 -375
13z m287 -118 c113 -30 156 -86 156 -203 0 -87 -35 -162 -98 -209 -53 -40 -96
-53 -194 -60 l-78 -6 1 99 c1 55 4 162 8 239 l6 140 35 6 c61 11 104 9 164 -6z"
        />
        <path
          d="M2405 1771 c-32 -12 -49 -23 -47 -32 34 -134 35 -157 32 -484 -6
-587 -8 -534 19 -556 29 -24 64 -24 119 1 33 15 42 24 38 37 -25 79 -50 513
-30 513 14 0 220 -212 386 -396 155 -172 208 -209 253 -180 27 18 50 49 58 81
5 16 -6 27 -51 55 -55 34 -434 396 -475 454 l-20 29 159 156 c257 252 271 277
181 320 -54 26 -64 26 -72 1 -10 -32 -130 -187 -209 -270 -158 -166 -206 -213
-212 -208 -3 4 -1 98 4 209 10 225 5 264 -34 279 -33 13 -40 12 -99 -9z"
        />
        <path
          d="M3420 1784 c-8 -3 -31 -12 -51 -20 l-35 -15 17 -68 c25 -100 33 -328
20 -637 -13 -304 -9 -341 41 -358 29 -10 89 3 121 26 16 12 16 18 3 83 -17 83
-33 455 -19 455 13 0 248 -242 391 -402 67 -75 137 -146 156 -157 64 -40 118
-20 146 54 10 25 9 32 -5 40 -74 44 -124 85 -262 219 -87 84 -185 184 -217
220 l-59 67 180 177 c196 192 218 220 209 255 -5 23 -70 67 -97 67 -8 0 -24
-20 -37 -44 -13 -23 -48 -74 -78 -112 -79 -99 -316 -346 -324 -337 -3 4 -3
100 1 212 3 112 3 216 -1 230 -10 38 -57 59 -100 45z"
        />
        <path
          d="M4531 1783 l-194 -3 9 -63 c5 -34 9 -280 9 -547 l0 -485 259 -3 c219
-2 263 0 282 13 32 21 39 55 20 100 -13 31 -20 36 -38 31 -71 -19 -157 -27
-268 -24 -69 2 -124 6 -122 11 1 4 2 93 2 197 l0 190 173 0 c215 0 248 13 233
92 l-6 36 -195 -6 -195 -5 0 172 0 171 88 1 c181 2 267 -5 323 -26 17 -6 40
41 41 86 2 55 -28 69 -136 67 -50 -2 -178 -4 -285 -5z"
        />
      </g>
    </svg>
  )
}

export default Logo
